import { render, staticRenderFns } from "./AppAccessControl.vue?vue&type=template&id=1b7bdd11&scoped=true&"
import script from "./AppAccessControl.vue?vue&type=script&lang=js&"
export * from "./AppAccessControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7bdd11",
  null
  
)

export default component.exports